// The offer's own $0 magnet sheet in the cart (issue #5218 item 9): "Free Photo
// Magnets (offer) — $0", so the parent sees the deal survive to checkout.
//
// Matched by NAME -- the same contract the server uses (Addon::FREE_MAGNETS_OFFER_NAME,
// seeded by migration and looked up by name because ids differ across restores).
// The client has no other signal: unit_price is $0 for the free sheet but the
// name is what tells it apart from a paid magnet sheet whose base package was
// free.
export const FREE_MAGNETS_OFFER_ADDON = 'Free Photo Magnets (offer)';

export const isFreeOfferAddon = (addon) => (addon?.name || '').trim() === FREE_MAGNETS_OFFER_ADDON;

// The cart line title for the free sheet's group.
export const freeOfferLineTitle = (addon) => `${(addon?.name || '').trim()} — $0`;
